// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.breadcrumb-background {
  border-top: 1px solid #444343;
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, #065b9d, white);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.6em 0 0 0;
}
.breadcrumb-background h6 {
  color: white;
  padding-left: 10px;
  font-weight: 500;
  font-size: 1.1em;
  margin-left: 12px;
}

.crumb-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

@media screen and (max-width: 927px) {
  .breadcrumb-background {
    height: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/BreadCrumb.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;AAKJ;AAHI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAKR;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAKJ;;AAFA;EACI;IACI,YAAA;EAKN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"global/Colors\";\n\n.breadcrumb-background {\n    border-top: 1px solid $grey4a;\n    width: 100%;\n    height: 60px;\n    background: linear-gradient(90deg, $dk-pearl-blue, white);\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    padding: .6em 0 0 0;\n\n    & h6 {\n        color: white;\n        padding-left: 10px;\n        font-weight: 500;\n        font-size: 1.1em;\n        margin-left: 12px;\n    }\n}\n.crumb-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n@media screen and (max-width: 927px) {\n    .breadcrumb-background {\n        height: 90px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
